import styles from './style.module.scss';
import { Row, Col, Descriptions } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DeleteIcon, EditIcon } from 'icons';
import useWaitingLists from '../useWaitingLists';
import moment from 'moment';

const Single = ({}) => {
  const { t } = useTranslation();

  const { singleItem, extrastockTypes } = useWaitingLists(false, false);

  const title = t('CONTATTI DI EMERGENZA');

  return (
    <div>
      <PageHeader title={title}>
        <Row gutter={16}>
          <Col>
            <Link to={'edit'}>
              <Button icon={<EditIcon />} big iconMargin type={'secondary'}>
                {t('MODIFICA')}
              </Button>
            </Link>
          </Col>
          <Col>
            <Link to={'delete'}>
              <Button
                icon={<DeleteIcon />}
                big
                iconMargin
                type={'red'}
                upperCase
              >
                {t('Cancella')}
              </Button>
            </Link>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Insegna')}>
            {singleItem?.company?.name}
          </Descriptions.Item>
          <Descriptions.Item label={t('Data dal')}>
            {singleItem?.date_from && moment(singleItem?.date_from).format('DD MMMM YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label={t('Data al')}>
            {singleItem?.date_to && moment(singleItem?.date_to).format('DD MMMM YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label={t('Tipologia Stock')}>
            {extrastockTypes[singleItem?.extrastock_type]}
          </Descriptions.Item>
          <Descriptions.Item label={t('Nome richiedente')}>
            {singleItem?.manager_name}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  );
};

export default Single;
